import React, { useState } from "react";
import axios from "axios";
import "./ContactUs.css"; // Make sure to create this CSS file

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    city: "",
    mobile: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Replace with your actual backend endpoint
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/contact/query`,
        formData
      );
      console.log(response.data);
      alert("Query submitted successfully");
      setFormData({ name: "", city: "", mobile: "", message: "" }); // Reset form
    } catch (error) {
      console.error("Error submitting query:", error);
      alert("Failed to submit query");
    }
  };

  return (
    <div className="contact-us-container">
      <div className="contact-info">
        <h2>Contact Us</h2>
        <p>
          <strong>Address:</strong> Plot 231, Phase-1, Industrial Area,
          Panchkula, Haryana, India (134113)
        </p>
        <p>
          <strong>Phone:</strong> +91-8725092149
        </p>
        {/* WhatsApp Button */}
        <a
          href="https://wa.me/+918725092149?text=I want to take franchise of your company. My Working city is: "
          className="whatsapp-button"
          target="_blank"
          rel="noopener noreferrer"
        >
          WhatsApp Us
        </a>
      </div>
      <div className="query-form">
        <form onSubmit={handleSubmit}>
          <h2>Submit a Query</h2>
          <input
            type="text"
            name="name"
            placeholder="Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="city"
            placeholder="City"
            value={formData.city}
            onChange={handleChange}
            required
          />
          <input
            type="tel"
            name="mobile"
            placeholder="Mobile Number"
            value={formData.mobile}
            onChange={handleChange}
            maxLength="10"
            required
          />

          <textarea
            name="message"
            placeholder="Your Message"
            value={formData.message}
            onChange={handleChange}
          ></textarea>
          <button type="submit">Submit</button>
        </form>
      </div>
    </div>
  );
};

export default ContactUs;
